import Swiper from 'swiper';
import { Pagination, EffectFade, Thumbs, Autoplay } from 'swiper/modules';

export default () => {
    const nodeSelectors = {
        heroSlider: '[js-hero-slider="slider"]',
        heroContentSlider: '[js-heroContent-slider="slider"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.heroSlider)) {
            return
        }

        initHeroSlider()
    }

    function initHeroSlider() {
        const heroSlider = new Swiper(nodeSelectors.heroSlider, {
            modules: [Pagination, EffectFade, Thumbs, Autoplay],
            slidesPerView: 1,
            speed: 800,
            autoplay: {
                delay: 5000,
            },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // }
            
        });

        const heroContentSlider = new Swiper(nodeSelectors.heroContentSlider, {
            modules: [Pagination, EffectFade, Thumbs, Autoplay],
            slidesPerView: 1,
            effect: 'fade',
            autoplay: {
                delay: 5000,
            },
            fadeEffect: {
                crossFade: true
            },
            thumbs: {
                swiper: heroSlider
            },
            pagination: {
                el: '.hero-section .swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                // 750: {
                //     slidesPerView: 2.2,
                // },
                // 1100: {
                //     slidesPerView: 3.2,
                //     spaceBetween: 70
                // }
            }
        });
    }

    return Object.freeze({
        init,
    })
}